import React, { useState } from "react";
import { Link } from "react-router-dom";
import jobsData from "../../data/jobsData";
import "./JobListings.css";
import Footer from "../../components/Home/footer/Footer";

function JobListings() {
  const [selectedDepartment, setSelectedDepartment] = useState("All");
  const [selectedJobType, setSelectedJobType] = useState("All");
  const [selectedLocation, setSelectedLocation] = useState("All");
  const [sortBy, setSortBy] = useState("Sort By");

  const uniqueDepartments = ["All", ...new Set(jobsData.map((job) => job.department))];
  const uniqueJobTypes = ["All", ...new Set(jobsData.map((job) => job.type))];
  const uniqueLocations = ["All", "Remote", "Onsite"];
  const sortOptions = ["Sort By", "Newest", "Oldest", "Title A-Z", "Title Z-A"];

  const filteredJobs = jobsData
    .filter((job) =>
      selectedDepartment === "All" ? true : job.department === selectedDepartment
    )
    .filter((job) =>
      selectedJobType === "All" ? true : job.type === selectedJobType
    )
    .filter((job) => {
      if (selectedLocation === "All") return true;
      if (selectedLocation === "Remote") return job.location.includes("Remote");
      if (selectedLocation === "Onsite") return !job.location.includes("Remote");
      return true;
    })
    .sort((a, b) => {
      if (sortBy === "Newest") {
        return new Date(b.posted) - new Date(a.posted);
      } else if (sortBy === "Oldest") {
        return new Date(a.posted) - new Date(b.posted);
      } else if (sortBy === "Title A-Z") {
        return a.title.localeCompare(b.title);
      } else if (sortBy === "Title Z-A") {
        return b.title.localeCompare(a.title);
      }
      return 0;
    });

  return (
    <div>
      <div className="jobs-section-container">
        <h2 className="jobs-header">Job Openings</h2>

        {/* Department filter buttons */}
        <div className="department-buttons">
          {uniqueDepartments.map((dept, idx) => (
            <button
              key={idx}
              className={`filter-button ${selectedDepartment === dept ? "active" : ""}`}
              onClick={() => setSelectedDepartment(dept)}
            >
              {dept}
            </button>
          ))}
        </div>

        <div className="filters-container">
          <select
            value={selectedJobType}
            onChange={(e) => setSelectedJobType(e.target.value)}
          >
            <option value="All">Filter by Job Type</option>
            {uniqueJobTypes.map((type, idx) => (
              <option key={idx} value={type}>{type}</option>
            ))}
          </select>

          <select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="All">Filter by Location</option>
            {uniqueLocations.map((loc, idx) => (
              <option key={idx} value={loc}>{loc}</option>
            ))}
          </select>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="sort-dropdown"
          >
            {sortOptions.map((option, idx) => (
              <option key={idx} value={option}>{option}</option>
            ))}
          </select>
        </div>

        <div className="jobs-grid">
          {filteredJobs.map((job, index) => (
            <div className="job-card" key={index}>
              <div className="job-top">
                <h4>{job.title}</h4>
                <p className="posted">{job.posted}</p>
              </div>
              <p className="location">{job.location}</p>
              <p className="job-type">{job.type}</p>
              {job.stipend && <p><strong>Stipend:</strong> {job.stipend}</p>}
              {job.duration && <p><strong>Duration:</strong> {job.duration}</p>}
              {job.hours && <p><strong>Hours:</strong> {job.hours}</p>}
              <div className="job-actions">
                <Link to={`/jobs/${encodeURIComponent(job.title)}`} className="apply-button mr-2">
                  View Details
                </Link>
                {job.link && (
                  <a
                    href={job.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="apply-button"
                  >
                    External Apply
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default JobListings;
